"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChipStyleClasses = exports.generateIconCSSProperties = exports.generateChipCSSProperties = exports.getChipStyles = exports.CHIP_STYLES = void 0;
const data_1 = require("../../data");
exports.CHIP_STYLES = data_1.chipConfig;
const getChipStyles = (type, variant, state) => {
  return exports.CHIP_STYLES[type][variant][state];
};
exports.getChipStyles = getChipStyles;
const generateChipCSSProperties = (type, variant, state) => {
  const styles = (0, exports.getChipStyles)(type, variant, state);
  return {
    backgroundColor: styles.background,
    color: styles.color,
    ...(styles.border && {
      border: styles.border
    })
  };
};
exports.generateChipCSSProperties = generateChipCSSProperties;
const generateIconCSSProperties = (type, variant, state) => {
  const styles = (0, exports.getChipStyles)(type, variant, state);
  return {
    color: styles.color
  };
};
exports.generateIconCSSProperties = generateIconCSSProperties;
const getChipStyleClasses = (type, variant) => {
  return `hmf-chip-type-${type} hmf-chip-variant-${variant}`;
};
exports.getChipStyleClasses = getChipStyleClasses;
